import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const Archiving = ({title="ADMIN.BACKUP.MANUALLY_BACKUP"})=>{ 
    const {t} = useTranslation()
    return(
        <div className="wid-admin-full hig-full pos-a top--10 left--10 fx-cc " onClick={e=>{e.stopPropagation()}}>
            <div className={`z-3 wid-admin-m br-20 fx-d-c fx-cc shadow-s-noHover hig-l bgC-white`}>
                <ArchiveAnimate  />
                <div className="margt-6-vh fx-d-c fx-cc">
                    {/* <div>{t("ADMIN.BACKUP.MANUALLY_BACKUP")}</div> */}
                    <div>{t(title)}</div>
                    <div className="running_dot margt-s">{t("ADMIN.NETWORK_SETTING.PLEASE_WAIT")}</div>
                </div>
            </div>
        </div>
    )
}

const ArchiveAnimate =(props)=>{
    const [height1, setHeight1] = useState(100);
    const [height2, setHeight2] = useState(60);
    const [height3, setHeight3] = useState(20);

    useEffect(()=>{
        setTimeout(()=>{
            setHeight1(height3)
            setHeight2(height1)
            setHeight3(height2)
        },700)
    },[height1,height2,height3])

    return (<div className='h-20 w-60 fx-d-r fx-sbfe'>
        <div className='transition-ease-in-out w-25 bgC-light' style={{height:`${height1}px`}}></div>
        <div className='transition-ease-in-out w-25 bgC-light' style={{height:`${height2}px`}}></div>
        <div className='transition-ease-in-out w-25 bgC-light' style={{height:`${height3}px`}}></div>        
    </div>);	
}
export default Archiving;